module.exports = __webpack_public_path__ + "img/2.c0c5cd17.png";